// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart"};


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/dashboard/component/chart/chart.style.sass
// module id = U0Im
// module chunks = 0